import AppServices from "./appservices";

class SpeechService extends AppServices {

  HEADERS = new Headers()

  toBlob(audioChunks) {
    return new Blob(audioChunks, { 'type' : 'audio/mp3' });
  }

  appendFiles(file, conversationId) {
    const fd = new FormData();
    fd.append(`speech`, file);
    fd.append(`conversationId`, conversationId);
    return fd;
  }

  toText(audio, conversationId, signal) {
    const formData = this.appendFiles(audio, conversationId);
    return this.request("/speech-to-text", "POST", formData, null, { signal });
  }

  toAudio(text) {
    return this.request("/text-to-speech", "POST", { text });
  }
}

export default SpeechService;